import styled from "@emotion/styled";
import { AliasToken } from "antd/es/theme/internal";

export const StyledLabel = styled.label<{
    token: AliasToken;
    required?: boolean;
}>`
    display: block;
    font-size: ${({ token }) => token.fontSize}px;
    line-height: ${({ token }) => token.lineHeightSM};
    font-weight: 500;
    margin-bottom: 6px;
    font-family: ${({ token }) => token.fontFamily};

    &::after {
        content: "*";
        display: ${({ required }) => (required ? "inline-block" : "none")};
        margin-inline-end: ${({ token }) => token.marginXXS}px;
        color: ${({ token }) => token.colorError};
        font-size: ${({ token }) => token.fontSize}px;
    }
`;
